<template>
    <div class="OauthButtonList">
        <slot />
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';

    @Component
    export default class OauthButtonList extends Vue {
    }
</script>
